import { render, staticRenderFns } from "./DomainMigrateContent.vue?vue&type=template&id=78a84b4e"
import script from "./DomainMigrateContent.vue?vue&type=script&lang=js"
export * from "./DomainMigrateContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports